// src/pages/PetCard.js
import React, { useContext } from 'react';
import './PetCard.css';
import EmblaCarousel from '../components/EmblaCarousel'; // >>> Nuevo import
import LikeButton from '../components/LikeButton';
import ShareModal from '../components/ShareModal';
import { ModalContext } from '../context/ModalContext';
import { TabContext } from '../context/TabContext';
import ModalPetDetail from '../components/ModalPetDetail';
import ModalProfesionalDetail from '../components/ModalProfesionalDetail';
import { renderGenderIcon } from '../utils/genderIcons';
import { SlPaperPlane } from 'react-icons/sl';

function PetCard({ pet }) {
  const photos = pet.fotos || [];

  const { openModal, closeModal } = useContext(ModalContext);
  const { activeTab } = useContext(TabContext);
  const profesional = pet.profesional;

  const handleOpenShareModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    openModal(
      <ShareModal
        onClose={() => closeModal(activeTab)}
        shareUrl={`${window.location.origin}/pet/${pet.id}?modal=true`}
        shareText={`¡Mira a ${pet.nombre}, disponible en PetIt!`}
      />,
      {
        tab: activeTab,
        keepHeader: true,
        overlayClassName: 'share-modal-overlay',
      }
    );
  };

  const handleOpenModalDetail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    openModal(
      <ModalPetDetail petId={pet.id} />,
      {
        tab: activeTab,
        metadata: { petName: pet.nombre, petSexo: pet.sexo },
        overlayClassName: 'pet-detail-overlay'    //  IMPORTANTE para abrir los modales con el ancho máximo (Skeleton)
      }
    );
  };

  const handleOpenProfesionalDetail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!profesional) {
      console.error("No hay información del profesional para esta mascota.");
      return;
    }
    openModal(
      <ModalProfesionalDetail professionalId={pet.profesional.id} />,
      {
        tab: activeTab,
        metadata: { profName: profesional.nombre, profLogo: profesional.logo, profId: profesional.id },
        overlayClassName: 'pet-detail-overlay'
      }
    );
  };

  const truncatedHistoria = pet.historia
    ? pet.historia.length > 222
      ? pet.historia.substring(0, 222) + '...'
      : pet.historia
    : '';

  return (
    <div className="pet-card">
      <div className="pet-card-header">
        <div
          className="pet-card-header"
          onClick={handleOpenProfesionalDetail}
          style={{ cursor: 'pointer' }}
        >
          <img
            src={profesional.logo}
            alt={profesional.nombre}
            className="professional-logo"
            loading="lazy"
          />
          <span className="professional-name">{profesional.nombre}</span>
        </div>
      </div>

      {/* === Carrusel con EmblaCarousel reutilizable === */}
      <EmblaCarousel
        photos={photos}
        heightDesktop="500px"
        heightMobile="250px"
        showArrows={false}    /*{photos.length > 1}*/
        showDots={photos.length > 0}
        loop={true}
        inViewThreshold={0.2}
      />

      {/*
          Reemplazamos el Link que envolvía el contenido (pet-card-body)
          por un contenedor clickable que al pulsar abra ModalPetDetail.
      */}
      <div
        className="pet-card-body"
        onClick={handleOpenModalDetail}
        style={{ cursor: 'pointer' }}
      >
        <div className="pet-card-footer">
          <div className="pet-info">
            <div className="pet-gender">{renderGenderIcon(pet.sexo)}</div>
            <span className="pet-name">{pet.nombre}</span>
          </div>
          <div className="pet-actions">
            <LikeButton
              petId={pet.id}
              initialIsFavorite={pet.liked_by_user}
              initialLikeCount={pet.like_count}
            />
            <button
              className="pet-share-button"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenShareModal(e);
              }}
            >
              <SlPaperPlane style={{ color: 'gray', fontSize: '1.5rem' }} />
            </button>
          </div>
        </div>
        <div className="pet-history">{truncatedHistoria}</div>
      </div>
    </div>
  );
}

export default PetCard;
